import { ErrorHandler, Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const CHUNK_LOAD_ERROR_PATTERN = /failed to fetch dynamically imported module|loading chunk [\d\w]+ failed/i;
const LAST_RELOAD_KEY = 'chunkLoadErrorLastReloadTimestamp';
const RELOAD_COOLDOWN_MILLISECONDS = 30_000;

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  handleError(error: unknown): void {
    if (isPlatformBrowser(this.platformId) && this.isChunkLoadError(error) && this.canReload()) {
      this.recordReload();
      window.location.reload();
      return;
    }

    console.error(error);
  }

  private isChunkLoadError(error: unknown): boolean {
    const message = error instanceof Error ? error.message : String(error);
    return CHUNK_LOAD_ERROR_PATTERN.test(message);
  }

  /**
   * Allows a reload unless one happened within the cooldown window. The cooldown prevents
   * an infinite reload loop when the chunk is genuinely missing, while still letting a later
   * deploy in the same tab session self-heal.
   */
  private canReload(): boolean {
    try {
      const lastReloadTimestamp = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
      return !lastReloadTimestamp || Date.now() - lastReloadTimestamp > RELOAD_COOLDOWN_MILLISECONDS;
    } catch {
      return false;
    }
  }

  private recordReload(): void {
    try {
      sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    } catch {
      // sessionStorage unavailable; canReload() will already have returned false
    }
  }
}
